import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/job/${':jobId' | number}/groups`;

export type * from './viewModel';

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId/groups`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/job/${jobId}/groups`;
